"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableMediumIcon = exports.TableMastheadIcon = void 0;
var React = require("react");
var SpacesMastheadTable_1 = require("../../../gen-src/icons/SpacesMastheadTable");
var SpacesMediumTable_1 = require("../../../gen-src/icons/SpacesMediumTable");
var SpacesMediumTableCertified_1 = require("../../../gen-src/icons/SpacesMediumTableCertified");
var PlaceStyles_1 = require("../style/PlaceStyles");
function TableMastheadIcon() {
    return React.createElement(SpacesMastheadTable_1.SvgSpacesMastheadTable, { className: PlaceStyles_1.placePageIconClass });
}
exports.TableMastheadIcon = TableMastheadIcon;
function TableMediumIcon(props) {
    return props.isCertified ? React.createElement(SpacesMediumTableCertified_1.SvgSpacesMediumTableCertified, null) : React.createElement(SpacesMediumTable_1.SvgSpacesMediumTable, null);
}
exports.TableMediumIcon = TableMediumIcon;
//# sourceMappingURL=TableIcon.js.map